import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { FaPhone, FaEnvelope, FaFacebookF, FaTwitter, FaLinkedin, FaInstagram } from 'react-icons/fa';

const Footer = () => {

    const currentYear = new Date().getFullYear();

    return (
        <footer className="site-footer">
            <div className="footer-content">
                <div className="footer-section map-section">
                    <h3>Find Us Here</h3>
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3722.2789029757055!2d79.00425507471634!3d21.101444085279294!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bd4955ae1d75a6d%3A0x639a1ab160553db3!2sPriyadarshini%20College%20of%20Engineering!5e0!3m2!1sen!2sin!4v1755798572486!5m2!1sen!2sin"
                        width="100%"
                        height="100%"
                        style={{ border: 0, borderRadius: '8px' }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="PCE College Location"
                    ></iframe>
                </div>

                <div className="footer-section about">
                    <h3>Address</h3>
                    <p>
                        Priyadarshini College of Engineering<br />
                        Near C.R.P.F. Campus,<br />
                        Hingna, Nagpur - 440019,<br />
                        Maharashtra
                    </p>
                    <div className="contact-info">
                        <span><FaPhone /> +91-0712-2230665</span>
                        <span><FaEnvelope /> acmwpcenagpur@gmail.com</span>
                    </div>
                    <div className="social-icons">
                        <a href="https://x.com/pceacm_w" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
                        <a href="https://www.linkedin.com/company/pce-acm-w-student-chapter/posts/?feedView=all" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
                        <a href="https://www.instagram.com/pceacmw/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
                        <a href="https://www.facebook.com/profile.php?id=61581388524369" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
                    </div>
                </div>

                <div className="footer-section links">
                    <h3>Quick Links</h3>
                    <ul>
                        <li><Link to="/about">About Us</Link></li>
                        <li><Link to="/contact">Contact Us</Link></li>
                        <li><a href="https://www.acm.org/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a></li>
                        <li><a href="https://www.acm.org/membership/acm-hq-contact" target="_blank" rel="noopener noreferrer">ACM-W Member Services</a></li>
                        <li><a href="https://india.acm.org/acm-w-india/events" target="_blank" rel="noopener noreferrer">Chapter Events</a></li>
                    </ul>
                </div>

                <div className="footer-section newsletter">
                    <h3>Newsletter</h3>
                    <p>Stay updated with the latest news, events, and opportunities. Join us on the journey of innovation!</p>
                </div>
            </div>
            <div className="footer-bottom">
                <p>&copy; {currentYear} PCE ACM-W Student Chapter. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;